<!--
component: KakuShinKamiPrint.vue
author: Izumi
description: 台帳記載証明view
@props : 
 data: 台帳記載証明書閲覧画面(BrowseDaichoKakuShin.vue)のコンポーネントインスタンスデータ
 -->
 <template>
  <div class="all-print" >
    <section  id="print-obj-kami" class="A4 MSPGOTHIC elevation-4 mx-auto" style="position: relative; min-height: 297mm;">
      <v-simple-table :light="false" :dark="false" class="A4 pa-4 pb-1 MSPGOTHIC" dense>
        <template v-slot:default>

          <thead>
            <tr>
              <td colspan="3" style="height: 4px !important;">様式1-2</td>
            </tr>
            <tr>
              <td class="header-font" style="text-align:center;" colspan="24">建築確認申請（計画通知）台帳記載証明申請書</td>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
              <td colspan="1" style="height: 4px !important;"></td>
            </tr>

            <!-- 申請書の場合 -->
            <tr>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="12" class="border-tx cellHeight-28 font-size-11">(申請先)横浜市長  証明書の発行を申請します</td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
            </tr>
            <tr>
              <td colspan="1" class="cellHeight-35"></td>
              <td colspan="1" rowspan="3" class="border-box px-0 text-vertical cellHeight-35 font-size-13">
                <svg width="28" height="94" xmlns="http://www.w3.org/2000/svg"><text x="14" y="20" writing-mode="tb" style="font-size: 13pt !important;">申請者</text></svg></td>
              <td colspan="11" class="border-tr cellHeight-35 font-size-13">住所</td>
              <td colspan="1" class="cellHeight-35"></td>
              <td colspan="1" class="cellHeight-35"></td>
              <td colspan="1" class="cellHeight-35"></td>
              <td class="font-size-12 cellHeight-35" style="text-align:left;" colspan="1">第</td>
              <!-- 下記非表示 -->
              <!-- <td colspan="2" class="cellHeight-35 font-size-12" style="text-align:center;padding-left:0px;padding-right:8px;">{{ data.issue.no }}</td> -->
              <td colspan="2" class="cellHeight-35 font-size-12"></td>
              <td colspan="1" class="cellHeight-35" style="padding-left: 0px;">号</td>
              <td colspan="1" class="cellHeight-35"></td>
              <!-- <td colspan="1" class="cellHeight-22"></td> -->
            </tr>
            <tr>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="11" class="border-right cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <!-- 年月日に入る数字を非表示にするため『空間を保持するスペース（&nbsp;）』に置換
                <td colspan="4" class="font-size-12 cellHeight-22 pr-1" style="text-align:left;white-space:nowrap;">{{ issueDateFormat(data.issue.date) }}</td> -->
              <td colspan="4" class="font-size-12 cellHeight-22 pr-1" style="text-align:left;white-space:nowrap;">{{ issueDateFormat(data.issue.date).replace(/[0-9]/g, '&nbsp;') }}</td>
              <td colspan="1" class="cellHeight-22"></td>
              <!-- <td colspan="1" class="cellHeight-22"></td> -->
            </tr>
            <tr>
              <td colspan="1" class="cellHeight-35"></td>
              <td colspan="11" class="border-br cellHeight-35 font-size-13">氏名</td>
              <td colspan="1" class="cellHeight-35"></td>
              <td colspan="1" class="cellHeight-35"></td>
              <td colspan="1" class="cellHeight-35"></td>
              <td colspan="1" class="cellHeight-35"></td>
              <td colspan="1" class="cellHeight-35"></td>
              <td colspan="1" class="cellHeight-35"></td>
              <td colspan="1" class="cellHeight-35"></td>
              <td colspan="1" class="cellHeight-35"></td>
              <td colspan="1" class="cellHeight-35"></td>
            </tr>
            <!-- 約束文章 -->
            <tr>
              <td class="font-size-12 cellHeight-28" style="text-align:center;" colspan="22">次のとおり{{ data.issue.ledgerType }}に記載してある事項と相違ないことを証明します。</td>
            </tr>
            <!-- 建築・変更・中間・検査済番号 -->
            <tr>
              <td colspan="7" class="item-title font-size-11 cellHeight-35 px-1">１. 建築確認申請受付番号・年月日</td>
              <td colspan="9" class="font-size-11 cellHeight-35">{{ data.ukeNo == ('' || null) ? 'なし' : data.ukeNo }}</td>
              <td class="font-size-11 cellHeight-35" style="text-align:left;" colspan="9">{{ data.ukeDay }}</td>
            </tr>
            <tr>
              <td colspan="7" class="item-title font-size-11 cellHeight-35 px-1">２. 建築確認申請確認番号・年月日</td>
              <td colspan="9" class="font-size-11 cellHeight-35">{{ data.kknnNo == ('' || null) ? 'なし' : data.kknnNo }}</td>
              <td class="font-size-11 cellHeight-35" style="text-align:left;" colspan="9">{{ data.kknnDay }}</td>
            </tr>
            <tr>
              <td colspan="7" class="item-title font-size-11 cellHeight-35 px-1">３. 検査済証交付年月日</td>
              <td colspan="9" class="font-size-11 cellHeight-35"></td>
              <td class="font-size-11 cellHeight-35" style="text-align:left;" colspan="9">{{ data.chukanDay1 }}</td>
            </tr>
            <!-- 建築物の概要 -->
            <tr>
              <td class="item-title text-left font-size-11 cellHeight-28 pl-1" colspan="22">４. 建築物の概要</td>
            </tr>
            <tr>
              <td colspan="1" class="cellHeight-22"></td>
              <td class="item-title text-left font-size-11 cellHeight-22 pl-2 pr-1" colspan="5">(1) 敷地の地名地番</td>
              <td class="text-left font-size-11 cellHeight-22" style="max-width:566px;" colspan="18">横浜市{{ data.build.gaiyo.placeLotNo1 }}</td>
            </tr>
            <!-- 敷地の地名地番 2つ目 -->
            <tr v-if="data.build.gaiyo.placeLotNo2">
              <td colspan="1" class="cellHeight-22"></td>
              <td class="item-title text-left font-size-11 cellHeight-22 pl-2 pr-1" colspan="5"></td>
              <td class="text-left font-size-11 cellHeight-22" style="max-width:566px;" colspan="18">{{ data.build.gaiyo.placeLotNo2 }}</td>
            </tr>
            <tr>
              <td colspan="1" class="cellHeight-22"></td>
              <td class="item-title text-left font-size-11 cellHeight-22 pl-2 pr-1" colspan="5">(2) 主要用途</td>
              <td class="text-left font-size-11 cellHeight-22" colspan="18">{{ data.build.gaiyo.mainUse }}</td>
            </tr>
            <tr>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="5" class="text-left font-size-11 cellHeight-22 pl-2 pr-1">(3) 敷地面積</td>
              <td colspan="4" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="4" class="font-size-11 MSGOTHIC cellHeight-22" style="text-align:right;">{{ data.build.gaiyo.siteArea }} {{ data.build.gaiyo.unitSiteArea }}</td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
            </tr>
            <tr>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="5" class="item-title text-left font-size-11 cellHeight-22 pl-2 pr-1">(4) 建築面積</td>
              <td colspan="4" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="4" class="font-size-11 MSGOTHIC cellHeight-22" style="text-align:right;">{{ data.build.gaiyo.buildAreaApp }} {{ data.build.gaiyo.unitBuildAreaApp }}</td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
            </tr>
            <tr>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="5" class="item-title text-left font-size-11 cellHeight-22 pl-2 pr-1">(5) 延べ面積</td>
              <td colspan="4" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="4" class="font-size-11 MSGOTHIC cellHeight-22" style="text-align:right;">{{ data.build.gaiyo.totalAreaApp }} {{ data.build.gaiyo.unitTotalAreaApp }}</td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
            </tr>

            <tr>
              <td colspan="1" class="cellHeight-22"></td>
              <td class="item-title text-left font-size-11 cellHeight-22 pl-2" colspan="5">(6) 工事種別</td>
              <td class="text-left font-size-11 cellHeight-22" colspan="18">{{ data.build.gaiyo.constructType }}</td>
            </tr>
            

            <tr>
              <td colspan="1" class="cellHeight-22"></td>
              <td class="item-title text-left font-size-11 cellHeight-22 pl-2 pr-0" colspan="5" style="padding-right:0px;">(7) 主たる建築物の構造</td>
              <td class="text-left font-size-11 cellHeight-22" colspan="18">{{ data.build.gaiyo.struct }}</td>
            </tr>
            <tr>
              <td colspan="1" class="cellHeight-22"></td>
              <td class="item-title text-left font-size-11 cellHeight-22 pl-2" colspan="5" style="padding-right:0px;">(8) 主たる建築物の階数</td>
              <td class="text-left font-size-11 cellHeight-22 " colspan="6" style="padding-right:0px;">地階を除く階数(地上階数)</td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td class="text-right font-size-11 cellHeight-22" colspan="2" style="padding-right:36px;">{{ data.build.gaiyo.ground }}</td>
              <td colspan="1" class="cellHeight-22" style="padding-left: 0px;">階</td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
            </tr>
            <tr>
              <td colspan="1" class="cellHeight-22"></td>
              <td class="text-left font-size-11 cellHeight-22" colspan="5"></td>
              <td class="text-left font-size-11 cellHeight-22 pr-0" colspan="6">地階の階数</td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td class="text-right font-size-11 cellHeight-22" colspan="2" style="padding-right:36px;">{{ data.build.gaiyo.underGround }}</td>
              <td colspan="1" class="cellHeight-22" style="padding-left: 0px;">階</td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
            </tr>
            <tr>
              <td colspan="1" class="cellHeight-22"></td>
              <td class="item-title text-left font-size-11 cellHeight-22 pl-2" colspan="5">(9) 棟数</td>
              <td class="text-left font-size-11 cellHeight-22" colspan="6"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td class="text-right font-size-11 cellHeight-22" colspan="2" style="padding-right:36px;">{{ data.build.gaiyo.buildNum }}</td>
              <td colspan="1" class="cellHeight-22" style="padding-left: 0px;">棟</td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
              <td colspan="1" class="cellHeight-22"></td>
            </tr>

            <!-- ここから 5. -->
            <tr>
              <td class="item-title text-left font-size-11 cellHeight-28 pl-1" colspan="22">5. 建築主</td>
            </tr>
            <tr>
              <td colspan="1" class="cellHeight-22"></td>
              <td class="item-title text-left font-size-11 cellHeight-22" colspan="5">(1) 住所</td>
              <td class="text-left font-size-11 cellHeight-22" :style="{'max-width': !data.build.architectInfo.address2 ? '566px' : '283px'}" :colspan="!data.build.architectInfo.address2 ? '18' : '9'">{{ data.build.architectInfo.address1 }}</td>
              <td v-if="data.build.architectInfo.address2" class="text-left font-size-11 cellHeight-22" style="max-width:283px;" colspan="9">{{ data.build.architectInfo.address2 }}</td>
            </tr>
            <tr>
              <td colspan="1" class="cellHeight-22"></td>
              <td class="item-title text-left font-size-11 cellHeight-22" colspan="5">(2) 氏名</td>
              <td class="text-left font-size-11 cellHeight-22" :style="{'max-width': !data.build.architectInfo.name2 ? '566px' : '283px'}" :colspan="!data.build.architectInfo.name2 ? '18' : '9'">{{ data.build.architectInfo.name1 }}</td>
              <td v-if="data.build.architectInfo.name2" class="text-left font-size-11 cellHeight-22" style="max-width:283px;" colspan="9">{{ data.build.architectInfo.name2 }}</td>
            </tr>
            <tr>
              <td colspan="1" class="cellHeight-22"></td>
              <td class="item-title text-left font-size-11 cellHeight-22" colspan="5">(3) 上記以外の建築主数</td>
              <td v-if="data.build.architectInfo.joinNum >= 1" class="text-left font-size-11 cellHeight-22" colspan="18">{{ data.build.architectInfo.joinNum }} 人</td>
              <td v-else class="text-left font-size-11 cellHeight-22" colspan="18">{{ data.build.architectInfo.joinNum }} </td>
            </tr>

          </tbody>
          
        </template>
      </v-simple-table>
      
      <!-- 注意文エリア (ページ最下部に固定) -->
      <div class="notice-bottom" style="position: absolute; bottom: 20px; left: 0; right: 0; padding: 8px 16px; font-size: 10pt; line-height: 1.4; color: black; text-align: left; background-color: white;" v-html="noticeAppFormText">
      </div>
      <!-- 確認番号フッター (独立したレイヤー) -->
      <div style="position: absolute; bottom: 0; right: 16px; padding: 4px 0; font-size: 10pt; color: black;">
        （{{ data.ukeNo == ('' || null) ? 'なし' : data.ukeNo }}）
      </div>
    </section>
  </div>
</template>
<script>
import Const from '../../common/constants.js'
export default {
	name: 'KakuShinKamiPrint',
	props:{
    data: {
      type: Object,
      required: true,
    },
  },
	data() {
		return {
			title:['確認申請台帳','変更申請台帳','中間検査台帳','完了検査台帳','建築確認台帳'],
      isIppan: false,
      // Kept for consistency with certificate/appForm split in other views; unused here.
      typeArr: ['certificate','appForm'],
      noticeAppFormText: '',
		}
	},
	async mounted() {
    // 注意文を読み込み
    // 【編集対象】public/notices/notice_appForm.html を編集すると、このコンポーネントの注意文表示が変更されます
    // 【表示箇所】様式1（申請書）のPDF出力時の注意文エリア
    try {
      const response = await fetch('/ges/notices/notice_appForm.html');
      this.noticeAppFormText = response.ok ? await response.text() : '';
    } catch (error) {
      this.noticeAppFormText = '';
    }
		if (this.unauthorized) {
			this.authDialog = true;
		}
		this.$store.commit('setCurrentPage', 3);
    // APIで取得したデータをセット

		//			var daicho_item = this.$store.state.seldaicho;
		var dbData = this.data;
		console.log(dbData);

    if (this.$store.state.userInfo.userName.includes('@')) {
      this.isIppan = true;}
	},
  methods: {
    // 空白埋め用関数 IEではpadStart関数が未対応のため自実装
    spacePadding(val, len) {
      for(let i = 0; i < len; i++){
        val = val + " ";
      }
      return val.substr(0,len);
    },
    // 日付フォーマット変換関数(yyyy/mm/dd → 元号yy年mm月dd日)
    issueDateFormat(val) {
      const def = Const.warekiDef;
      if(val != ''){
        var d = new Date(val);
        var era = '';
        for(let i = 0; i < def.length - 1; i++){
          let date1 = new Date((def[i].firstYear + '/' + def[i].startMonth + '/' + def[i].startDate));
          let date2 = new Date((def[i + 1].firstYear + '/' + def[i + 1].startMonth + '/' + def[i + 1].startDate));
          if(date1.valueOf() <= d.valueOf()){
            if(d.valueOf() < date2.valueOf()){
              era = def[i].era + ('  ' + new String(d.getFullYear() - def[i].firstYear + 1)).slice(-2);
            }else{
              era = def[i + 1].era + ('  ' + new String(d.getFullYear() - def[i + 1].firstYear + 1)).slice(-2);
            }
          }
        }
        return era + ' 年' + ('  ' + new String(d.getMonth() + 1)).slice(-2) + ' 月' + ('  ' + new String(d.getDate())).slice(-2) + ' 日';
      }
    },
    // 連名者表示形式変換関数
    joinPerson() {
      var join = '';
      for(let i = 0; i < this.data.build.architectInfo.joinPerson.length; i++) {
        if(i === this.data.build.architectInfo.joinPerson.length - 1){
          join += this.data.build.architectInfo.joinPerson[i];
        }else{
          join += this.data.build.architectInfo.joinPerson[i] + '、';
        }
      }
      return join;
    }
  },
}
</script>
<style scoped>
.A4 {
  height: 297mm !important;
  width: 210mm !important;
  position: relative;
}

.MSPGOTHIC {
  font-family: "MS PGothic",sans-serif;
}

.MSGOTHIC {
  font-family: "MS Gothic",sans-serif;
}

.header-font {
  font-size: 19pt !important;
  color: #000;
  height: 32px !important;
}

/* .footer-font {
  font-size: 11pt !important;
  color: #000;
} */

.item-title {
  white-space: nowrap;
}

.font-size-11 {
  font-size: 11pt !important;
}

.font-size-12 {
  font-size: 12pt !important;
}

.font-size-13 {
  font-size: 13pt !important;
}

.font-size-9 {
  font-size: 9pt !important;
}

.font-black {
  color: #000;
}

.text-vertical {
  writing-mode: vertical-rl;
  text-align: center;
  white-space: nowrap;
  margin: 0;
  line-height: 1em;
}

.border-top {
  border-top: solid 1px;
}

.border-right {
  border-right: solid 1px;
}

.border-top-left {
  border-top: solid 1px;
  border-left: solid 1px;
}

.border-top-right {
  border-top: solid 1px;
  border-right: solid 1px;
}

.border-box {
  border: solid 1px !important;
}

.border-tx {
  border-top: solid 1px;
  border-left: solid 1px;
  border-right: solid 1px;
}

.border-tr {
  border-top: solid 1px;
  border-right: solid 1px;
}

.border-bx {
  border-bottom: solid 1px !important;
  border-left: solid 1px;
  border-right: solid 1px;
}

.border-br {
  border-bottom: solid 1px !important;
  border-right: solid 1px;
}

/* tbody > tr > td {
  height: 25px !important;
} */

.cellHeight-35 {
  height: 35px !important;
}

.cellHeight-28 {
  height: 28px !important;
}

.cellHeight-24 {
  height: 24px;
}

.cellHeight-22 {
  height: 22px !important;
}

.cellHeight-8 {
  height: 8px !important;
}

.lineHeight {
  line-height: 15px;
}

/* v-simple-tableにデフォルトで付与してあるhoverを無効化 */
tr:hover {
  background-color: transparent !important;
}

thead:hover {
  background-color: transparent !important;
}

/* tbody > tr > td {
  border: solid 0.1px !important;
} */

/* v-simple-tableにデフォルトで付与してある下線を無効化 */
tbody > tr > td{
  border-bottom: none !important;
  border: none;
}

tfoot > tr > td {
  border-top: none !important;
}

.v-radio >>> .v-icon {
  font-size: 18px;
}

.v-input--radio-group {
  margin-top: 0px;
}

.v-radio >>> .v-input--selection-controls__input {
  margin-right: 0px !important;
}

.footer-font {
  position: absolute;
  bottom: 30px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 11pt;
}

</style>
